var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBuLiangShiJianWeihui(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: "1em",
    viewBox: "0 0 42 42"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 42,
    fill: "currentColor",
    rx: 8
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M28.563 16c.358.453.684.939.967 1.456l.858-.485a1.046 1.046 0 011.425.395 1.01 1.01 0 01-.382 1.378l-1.09.618c.242.753.411 1.545.486 2.365h1.15a1.023 1.023 0 010 2.046h-1.143a11.3 11.3 0 01-.483 2.37l1.083.611a1.01 1.01 0 01.374 1.391c-.29.492-.92.661-1.416.38l-.849-.48c-1.469 2.694-4.02 4.591-6.995 4.955V22.168a.954.954 0 00-.955-.954h-.182a.954.954 0 00-.954.954V33c-2.976-.364-5.525-2.264-6.994-4.955l-.848.48a1.045 1.045 0 01-1.425-.394 1.01 1.01 0 01.382-1.378l1.08-.61a11 11 0 01-.482-2.37h-1.147a1.023 1.023 0 010-2.046h1.15c.075-.823.244-1.612.485-2.365l-1.09-.618-.014-.008a1.01 1.01 0 01-.358-1.384c.289-.492.919-.66 1.415-.38l.855.484c.284-.517.61-1.003.968-1.456zm-7.339-6.995c2.519.12 4.554 2.244 4.772 4.934L26 14H16l.005-.061C16.23 11.17 18.38 9 21 9z"
  })));
}
export default SvgBuLiangShiJianWeihui;